import { FORM, GOALIDS, OTHERTASKS } from 'appConfig/enums'
import marketingIcon from 'appAssets/Marketing.png'
import financeIcon from 'appAssets/Finance.png'
import salesIcon from 'appAssets/Sales.png'
import hrIcon from 'appAssets/HR.png'
import customerServiceIcon from 'appAssets/Customer-Service.png'
import {
  BusinessGoal,
  BusinessGoalCategory,
  BusinessGoalTimeFrame,
  UserTaskItemStatus,
} from '__generated__/api-types-and-hooks'
import { BusinessGoalPriority } from '__generated__/api-types-and-hooks'

export const statusLabels = [
  { label: 'To Do', value: 'TODO' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Blocked', value: 'BLOCKED' },
  { label: 'Completed', value: 'DONE' },
  { label: 'Deleted', value: 'DELETED' },
  { label: 'Declined', value: 'ARCHIVED' },
]

export const taskPriorityStatus = {
  LOW_PRIORITY: 'Low',
  MEDIUM_PRIORITY: 'Medium',
  HIGH_PRIORITY: 'High',
}

export const userTaskItemStatusesStatus = {
  ARCHIVED: 'Declined',
  BLOCKED: 'Blocked',
  DONE: 'Completed',
  DRAFT: 'Draft',
  IN_PROGRESS: 'In Progress',
  PAUSED: 'Paused',
  TODO: 'To Do',
  CREATING: 'Creating',
  DELETED: 'Deleted',
}

export const goalCategoryLabelsValues = [
  { label: 'Communications', value: 'COMMUNICATIONS' },
  { label: 'Customer Service', value: 'CUSTOMER_SERVICE' },
  { label: 'Finance', value: 'FINANCE' },
  { label: 'Human Resources', value: 'HR' },
  { label: 'Information Technology', value: 'INFORMATION_TECHNOLOGY' },
  { label: 'Legal', value: 'LEGAL' },
  { label: 'Marketing', value: 'MARKETING' },
  { label: 'Operations', value: 'OPERATIONS' },
  { label: 'Production', value: 'PRODUCTION' },
  { label: 'Research & Development', value: 'RESEARCH_AND_DEVELOPMENT' },
  { label: 'Sales', value: 'SALES' },
  { label: 'Strategy', value: 'STRATEGY' },
]

export const taskPriorityLabelsValues = [
  { label: 'Low', value: 'LOW_PRIORITY' },
  { label: 'Medium', value: 'MEDIUM_PRIORITY' },
  { label: 'High', value: 'HIGH_PRIORITY' },
]

export const formKeys = {
  [FORM.USER_TASK_FORM]: [
    'name',
    'estimatedEffortInMinutes',
    'order',
    'taskPriority',
    'status',
    'category',
    'instructionForTask',
    'expectedEndDate',
    'startDate',
    'planId',
    'milestoneId',
    'assigneeId',
    'howToLinks',
    'goalId',
    'goalExpectedEndDate',
  ],
}
export const goalPriorityStatus = {
  LOW_PRIORITY: 'Low',
  MEDIUM_PRIORITY: 'Medium',
  HIGH_PRIORITY: 'High',
}
export const goalPriorityOptions = [
  { label: 'Low', value: 'LOW_PRIORITY' },
  { label: 'Medium', value: 'MEDIUM_PRIORITY' },
  { label: 'High', value: 'HIGH_PRIORITY' },
]

export const goalTimeFrameStatus = {
  SHORT_TERM: 'Short-Term',
  Medium_TERM: 'Medium-Term',
  LONG_TERM: 'Long-Term',
}

export const FilterTooltips = {
  SHORT_TERM: 'less than 6 months',
  Medium_TERM: '6 months to  2 years',
  LONG_TERM: 'More than 2 years',
}

export const categoryType = {
  COMMUNICATIONS: 'Communications',
  CUSTOMER_SERVICE: 'Customer Service',
  FINANCE: 'Finance',
  HR: 'Human Resources',
  INFORMATION_TECHNOLOGY: 'Information Technology',
  LEGAL: 'Legal',
  MARKETING: 'Marketing',
  OPERATIONS: 'Operations',
  PRODUCTION: 'Production',
  RESEARCH_AND_DEVELOPMENT: 'Research & Development',
  SALES: 'Sales',
  STRATEGY: 'Strategy',
}
export const GoalStatusLabels: Record<UserTaskItemStatus, string> = {
  [UserTaskItemStatus.Todo]: 'Not Started',
  [UserTaskItemStatus.InProgress]: 'In Progress',
  [UserTaskItemStatus.Done]: 'Completed',
  [UserTaskItemStatus.Paused]: 'Paused',
  [UserTaskItemStatus.Archived]: 'Archived',
  [UserTaskItemStatus.Blocked]: 'Blocked',
  [UserTaskItemStatus.Draft]: 'Draft',
  [UserTaskItemStatus.Creating]: 'Generating Plan',
  [UserTaskItemStatus.Deleted]: 'Deleted',
  [UserTaskItemStatus.Pending]: 'Pending',
}

export enum UserTaskItemStatusChips {
  Todo = 'TODO',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
  Paused = 'PAUSED',
}

export const getIconByCategory = (label) => {
  switch (label) {
    case categoryType.MARKETING:
      return marketingIcon
    case categoryType.FINANCE:
      return financeIcon
    case categoryType.SALES:
      return salesIcon
    case categoryType.HR:
      return hrIcon
    case categoryType.CUSTOMER_SERVICE:
      return customerServiceIcon
    default:
      return undefined
  }
}

export const goalDropdownItems = [
  {
    status: UserTaskItemStatus.Archived,
    label: 'Archive',
    selectedLabel: 'Unarchive',
    shouldShow: (goal?: BusinessGoal) => goal?.status !== UserTaskItemStatus.Done,
  },
  {
    status: UserTaskItemStatus.Done,
    label: 'Mark as complete',
    selectedLabel: 'Mark as incomplete',
    shouldShow: (goal?: BusinessGoal) =>
      goal?.status !== UserTaskItemStatus.Draft && goal?.status !== UserTaskItemStatus.Archived,
  },
  {
    status: UserTaskItemStatus.Paused,
    label: 'Pause',
    selectedLabel: 'Unpause',
    shouldShow: (goal?: BusinessGoal) => {
      // Only show the pause option in Active goals view (not in Archived or Draft)
      return (
        goal?.status !== UserTaskItemStatus.Archived &&
        goal?.status !== UserTaskItemStatus.Done &&
        goal?.status !== UserTaskItemStatus.Draft
      )
    },
  },
  {
    label: 'Update Action Plan',
    selectedLabel: 'Regenerating',
    shouldShow: (goal?: BusinessGoal) => {
      // hide the logic for now
      // const tasks = goal?.plan?.tasks
      // const hasStartedTasks = tasks?.some((task) => task && task.status !== UserTaskItemStatus.Todo)
      // return !hasStartedTasks
      return goal?.status !== UserTaskItemStatus.Archived && goal?.status !== UserTaskItemStatus.Draft
    },
  },
]

export const otherGoalIds = [GOALIDS.MY_ALL_PLAYS, GOALIDS.MY_OTHER_TASKS]
export const myOtherTasksGoal: BusinessGoal[] = [
  {
    name: OTHERTASKS.MY_ALL_PLAYS,
    goalPriority: BusinessGoalPriority.MediumPriority,
    progress: 0,
    goalId: 'all-plays',
    description:
      'View or update all plays (tasks) across all active goals.This includes "Miscellaneous Plays" and excludes plays from paused, archived, or completed goals.',
  },
  {
    name: OTHERTASKS.MY_OTHER_TASKS,
    goalPriority: BusinessGoalPriority.MediumPriority,
    progress: 0,
    goalId: 'other-tasks',
    description: 'View, update, or add plays (tasks) that are not tied to a specific goal.',
  },
]

export const goalsFilter = [
  {
    label: 'priorities',
    title: 'Priority',
    options: [
      { label: 'High', value: BusinessGoalPriority.HighPriority },
      { label: 'Medium', value: BusinessGoalPriority.MediumPriority },
      { label: 'Low', value: BusinessGoalPriority.LowPriority },
    ],
    disabled: false,
  },
  {
    label: 'timeFrames',
    title: 'Time Frame',
    options: [
      {
        label: 'Short-Term',
        value: BusinessGoalTimeFrame.ShortTerm,
        toolTipText: 'less than 6 months',
      },
      {
        label: 'Medium-Term',
        value: BusinessGoalTimeFrame.MediumTerm,
        toolTipText: '6 months to  2 years',
      },
      {
        label: 'Long-Term',
        value: BusinessGoalTimeFrame.LongTerm,
        toolTipText: 'More than 2 years',
      },
    ],
    disabled: false,
  },
  {
    label: 'statuses',
    title: 'Status',
    options: [
      { label: 'Not Started', value: UserTaskItemStatus.Todo },
      { label: 'In Progress', value: UserTaskItemStatus.InProgress },
      { label: 'Completed', value: UserTaskItemStatus.Done },
      { label: 'Paused', value: UserTaskItemStatus.Paused },
    ],
    disabled: false,
  },
]

export const kanbanFilters = [
  {
    label: 'businessName',
    title: 'Businesses',
    subTitle: 'Business',
    options: [],
    disabled: false,
  },
  {
    label: 'goalId',
    title: 'Goals',
    subTitle: 'Goal',
    options: [],
    disabled: false,
  },
  {
    label: 'assigneeId',
    title: 'Assignee',
    subTitle: 'Assignee',
    options: [],
    disabled: false,
  },
  {
    label: 'taskPriority',
    title: 'Priority',
    subTitle: 'Priority',
    options: [
      { label: 'High', value: BusinessGoalPriority.HighPriority },
      { label: 'Medium', value: BusinessGoalPriority.MediumPriority },
      { label: 'Low', value: BusinessGoalPriority.LowPriority },
    ],
    disabled: false,
  },
  {
    label: 'category',
    title: 'Business Function',
    subTitle: 'Function',
    options: [
      { label: 'Communications', value: BusinessGoalCategory.Communications },
      { label: 'Customer Service', value: BusinessGoalCategory.CustomerService },
      { label: 'Finance', value: BusinessGoalCategory.Finance },
      { label: 'Human Resources', value: BusinessGoalCategory.Hr },
      { label: 'Information Technology', value: BusinessGoalCategory.InformationTechnology },
      { label: 'Legal', value: BusinessGoalCategory.Legal },
      { label: 'Marketing', value: BusinessGoalCategory.Marketing },
      { label: 'Operations', value: BusinessGoalCategory.Operations },
      { label: 'Production', value: BusinessGoalCategory.Production },
      { label: 'Research & Development', value: BusinessGoalCategory.ResearchAndDevelopment },
      { label: 'Sales', value: BusinessGoalCategory.Sales },
      { label: 'Strategy', value: BusinessGoalCategory.Strategy },
    ],
    disabled: false,
  },
]
